import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { endOfYear, startOfYear } from 'date-fns'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

import Navbar from './_Navbar'
import { YearsGrid } from './_YearsGrid'

type Props = {
  date: Date
  onDateRangeChange: (startDate: Date, endDate: Date) => void
}

export const YearPicker = ({ date, onDateRangeChange }: Props) => {
  const [firstYear, setFirstYear] = React.useState(date.getFullYear() - 1)

  const handleOnSelectYear = useUnsafeCallback(
    (year: number) => {
      const newDate = new Date(year, 0)

      onDateRangeChange(startOfYear(newDate), endOfYear(newDate))
    },
    [onDateRangeChange]
  )

  const handleNextClick = useUnsafeCallback(() => {
    setFirstYear((currentFirstYear) => currentFirstYear + 12)
  }, [])

  const handlePreviousClick = useUnsafeCallback(() => {
    setFirstYear((currentFirstYear) => currentFirstYear - 12)
  }, [])

  return (
    <Box padding="s24" background="grey000White" width="s240">
      <Navbar
        firstYear={firstYear}
        onNextClick={handleNextClick}
        onPreviousClick={handlePreviousClick}
      />
      <YearsGrid
        firstYear={firstYear}
        selectedYear={date.getFullYear()}
        onSelectYear={handleOnSelectYear}
      />
    </Box>
  )
}
